module.exports = __webpack_public_path__ + "static/img/1_4_1.43a432f2.jpg";